import * as React from 'react';
import Slider, { Settings } from 'react-slick';

import './slick.css';

interface ICustomSliderProps extends Settings {
  children: React.ReactNode;
  ref?: React.Ref<Slider>;
}

export function CustomSlider({ children, ref, ...rest }: ICustomSliderProps) {
  return (
    <Slider {...rest} ref={ref}>
      {children}
    </Slider>
  );
}
